import AccountMarginMode from 'components/leverage/accountMarginMode';
import { isMobileOrTablet } from 'helpers/utils';
import useWindowSize from 'hooks/useWindowSize';
import MaterialDialog from 'UIKit/MaterialDialog';

import styles from '../index.module.scss';

type ChangeMarginModePopUpProps = {
  showModal: boolean;
  handleMarginModeClose: () => void;
  updateMarginModeFun: (args: { user_id: string | number; margin_mode: string }) => void;
  marginType: string;
  isolatedError?: { code: string };
  resetIsolatedError: () => void;
};

const ChangeMarginModePopUp = ({
  showModal,
  handleMarginModeClose,
  updateMarginModeFun,
  marginType,
  isolatedError,
  resetIsolatedError,
}: ChangeMarginModePopUpProps) => {
  const { isMobile } = useWindowSize();

  return (
    <MaterialDialog
      marginTopInherit={!isMobileOrTablet()}
      transition={isMobileOrTablet()}
      fullWidth={isMobile}
      open={showModal}
      contentClassName={styles.leverageModal}
      onClose={handleMarginModeClose}
    >
      {/* eslint-disable-next-line test-selectors/onSubmit */}
      <AccountMarginMode
        onCancel={handleMarginModeClose}
        onSubmit={updateMarginModeFun}
        marginType={marginType}
        isolatedError={isolatedError}
        resetIsolatedError={resetIsolatedError}
        showCrossIcon
      />
    </MaterialDialog>
  );
};

export { ChangeMarginModePopUp };
